/* istanbul ignore file */
export var PayButtonLevel;
(function (PayButtonLevel) {
    PayButtonLevel["balance"] = "balance";
    PayButtonLevel["transaction"] = "transaction";
    PayButtonLevel["balancePOP"] = "balancePOP";
})(PayButtonLevel || (PayButtonLevel = {}));
export const BANCONTACT_BRAND_ID = 'Bancontact/Mister Cash';
